<!--
 * @Author: your name
 * @Date: 2021-12-03 08:34:35
 * @LastEditTime: 2022-01-26 18:11:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \new-website-1123\src\views\special\fx101\page5.vue
-->
<template>
  <div class="fx101-page5 pt80">
    <div class="text-div">
      <ctitle titleb="防逃设计，" titles="杜绝害虫二次逃脱"></ctitle>
    </div>
    <div class="img-div">
      <img
        class="data-img"
        src="https://stkjiot.com/resources/special/stld/8.png"
        alt="上太科技"
        @load="imgLoad"
      />
      <div class="i-desc">
        <span class="line-span"></span>
        <p class="line-label">防逃阀门</p>
      </div>
    </div>
  </div>
</template>

<script>
import ctitle from "@/components/sTitle/title1.vue";
export default {
  name: "",
  components: {
    ctitle,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    imgLoad() {
      let div = document.querySelector(".fx101-page5");
      let img = div.querySelector(".data-img");
      let p = div.querySelector(".i-desc");
      p.style.left = `calc(21% + ${img.width / 2}px - 5px)`;
    },
  },
};
</script>

<style lang="scss" scoped>
.fx101-page5 {
  position: relative;
  height: 100vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 180px;
  .img-div {
    height: 78%;
    position: relative;
    margin-top: 60px;
    img {
      height: 100%;
      object-fit: contain;
    }
  }
  .i-desc {
    position: absolute;
    top: 63%;
    overflow: hidden;

    .line-span {
      display: block;
      position: absolute;
      top: 0px;
      left: 0;
      width: 0;
      height: 1px;
      background-color: rgba($color: #fff, $alpha: 0.5);
    }
    p {
      margin: 0;
      white-space: nowrap;
      color: $color-active;
      padding-left: 100px;
      position: relative;
      height: 0;
      // height: 16px;
      margin-top: 10px;
      overflow: hidden;
      font-weight: bold;
      font-size: 22px;
    }
  }
}
@media screen and (max-height: 800px) {
  .fx101-page5 {
    .img-div {
      height: 68%;
    }
  }
}
@media screen and (min-height: 800px) {
  .fx101-page5 {
    .img-div {
      height: 78%;
    }
  }
}

@media screen and (max-width: $mobile-width) {
  .fx101-page5 {
    height: auto;
    margin-top: 1.64rem;
    .img-div {
      height: unset;
      width: 38%;
      position: relative;
      margin-top: 30px;
      img {
        height: unset;
        width: 100%;
        object-fit: contain;
      }
    }
    .i-desc {
      position: absolute;
      top: 62%;
      overflow: hidden;
      width: 2rem;
      .line-span {
        width: 100%;
      }
      p {
        margin: 0;
        padding-left: 0;
        text-align: right;
        height: auto;
        // height: 16px;
        margin-top: 6px;
        font-size: 0.22rem;
      }
    }
  }
}
</style>
